export default {
  title: 'Non perdertelo!',
  description: 'Attiva le notifiche per restare aggiornato sul tuo ordine.',
  buttons: {
    enable: 'Attiva',
  },
};
